import { isEmpty, isNil } from 'lodash';

import {
  IUserInfoFieldsNames,
  userInfoFieldsNames,
} from '../../components/User/UserInfoFormFields/UserInfoFormFields.types';
import {
  IUserLegalInfoFieldsNames,
  userLegalInfoFieldsNames,
} from '../../components/User/UserLegalInfoFields/UserLegalInfoFields.types';
import { IUser } from '../../shared/ts/user';

const validateUserLegalInfoFields = (userToUpdate: IUser) => {
  const missingFields: IUserLegalInfoFieldsNames[] = [];
  for (const userLegalInfoFieldsName of userLegalInfoFieldsNames) {
    const value = userToUpdate[userLegalInfoFieldsName];
    if (isNil(value) || isEmpty(value))
      missingFields.push(userLegalInfoFieldsName);
  }
  return missingFields;
};

export const validateUserInfoFormFields = (userToUpdate: IUser) => {
  const missingFields: (IUserInfoFieldsNames | IUserLegalInfoFieldsNames)[] =
    [];
  for (const userInfoFieldsName of userInfoFieldsNames) {
    let value: unknown;
    if (userInfoFieldsName === 'id_document_number') {
      value = userToUpdate.id_document.number;
    } else if (userInfoFieldsName === 'id_document_expiry_date') {
      value = userToUpdate.id_document.expiry_date;
    } else {
      value = userToUpdate[userInfoFieldsName];
    }

    if (isNil(value) || isEmpty(value)) missingFields.push(userInfoFieldsName);
  }
  if (userToUpdate.is_legal_entity === 1)
    missingFields.push(...validateUserLegalInfoFields(userToUpdate));
  return missingFields;
};
